import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Dropdown, Grid, Icon, Menu } from 'semantic-ui-react';
import history from '../../History';
import { getAppearanceData } from '../../hooks/useAppearance';
import About from './About';
import AuthContext from '../../contexts/AuthContext';
import { AuthContextProps } from 'react-oidc-context';
import { SettingsContext } from '../../contexts/SettingsContext';

const helpFileLink = "https://helpfiles.fybsoftware.com.au/docs/CM2WebShare-user-manual-61x";


function LeftDropdown(isMobile: boolean, activeItem: string, aboutOnClick: Function, isAdmin: boolean, auth: AuthContextProps | undefined) {

    useEffect(() => {

    }, []);

    const handleLogout = async (authProps: AuthContextProps) => {
        await authProps.removeUser();
    };

    const renderExtraOptions = () => {
        if (isMobile) {
            let adminElem = null;
            if (isAdmin) {
                adminElem = <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/Admin')}>Admin</Dropdown.Item>
            }
            return (
                <React.Fragment>
                    {adminElem}
                    <Dropdown.Item style={{ cursor: 'pointer' }} active={activeItem === 'about'} onClick={() => {aboutOnClick()}} >About</Dropdown.Item>
                    <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => window.open(helpFileLink)}>Help</Dropdown.Item>
                </React.Fragment>
            );
        }
    }

    return (
        <Dropdown.Menu style={{ marginLeft: '-21px' }}>
            {renderExtraOptions()}
            <Dropdown.Item id='home-btn' style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/')}>Home</Dropdown.Item>
            <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/Themes')}>Themes</Dropdown.Item>
            <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/Statistics')}>Statistics</Dropdown.Item>

            {auth && auth !== null &&
                <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => {handleLogout(auth)}}>Log Out</Dropdown.Item>
            }
        </Dropdown.Menu>
    );
}

function NavMenu() {

    const activeItem: string = "";

    const { auth } = useContext(AuthContext);
    const { hasAdminPrivileges } = useContext(SettingsContext);

    const [logoImg, setLogoImg] = useState<string>("");
    const [fontColour, setFontColour] = useState<string>("");
    const [bgColour, setBgColour] = useState<string>("");
    const [openAbout, setOpenAbout] = useState<boolean>(false);

    useEffect(() => {
        async function getData() {
             let data = await getAppearanceData(auth);
 
             if (data) {
                 setLogoImg(data.logo)
                 setFontColour(data.fontColour)
                 setBgColour(data.backgroundColour);
             }
         }
         getData();
    }, [])

    const menuStyle = {
        backgroundColor: bgColour,
        color: fontColour,
        height: "65px",
        position: "relative",
        borderRadius: "0px !important"
    }

    const iconStyle = {
        paddingTop: "3vh",
        padding: "22px",
        paddingLeft: "5px",
        paddingBottom: "43px",
        color: "white",
    };

    const menuItemStyle = {
        color: fontColour
    }

    const showAboutModal = () => {
        setOpenAbout(!openAbout);
    };

    let adminBtn = null;
    if (hasAdminPrivileges) {
        adminBtn = 
            <Menu.Item
                id='admin-btn'
                name='admin'
                active={activeItem === 'admin'}
                style={menuItemStyle}
                onClick={() => history.push('/CM2WebShare/Admin')}
            >
                Admin
            </Menu.Item>
    }

    return (
        <div>
            <Menu className="menu" borderless inverted size='large' id="menu" style={menuStyle}>
                <Grid id="nav-bar">
                    <Grid.Row className="computer only row" style={{ display: 'flex' }}>
                        <Menu.Menu position='left' style={{ marginRight: '0px !important' }}>
                            <Dropdown icon={null} trigger={<Icon id="left-hamburger" link name='content' size='large' style={iconStyle} />}>
                                {LeftDropdown(false, activeItem, showAboutModal, hasAdminPrivileges, auth)}
                            </Dropdown>
                            <div>
                                <img src={logoImg!} style={{ marginLeft: "auto", marginRight: "auto", display: "block", cursor: 'pointer' }} id="logo" alt='FYB CM2WebShare Logo'
                                    onClick={() => history.push('/CM2WebShare/')} />
                            </div>
                            <div className="right menu" style={{ marginLeft: "auto", display: "flex" }}>
                                {adminBtn}
                                <Menu.Item
                                    id='about-btn'
                                    name='about'
                                    active={activeItem === 'about'}
                                    style={menuItemStyle}
                                    onClick={() => { showAboutModal() }}
                                >
                                    About
                                </Menu.Item>
                                <Menu.Item
                                    id='help-btn'
                                    name='help'
                                    active={activeItem === 'help'}
                                    style={menuItemStyle}
                                    onClick={() => window.open(helpFileLink)}
                                >
                                    Help
                                </Menu.Item>
                            </div>
                        </Menu.Menu>
                    </Grid.Row>

                    <Grid.Row className="tablet mobile only row">
                        <Menu.Menu position='left' style={{ marginRight: '0px !important', flexGrow: '2', display: 'flex' }}>
                            <Dropdown icon={null} trigger={<span style={{ whiteSpace: 'nowrap' }}><Icon id="left-hamburger" link name='content' size='large' style={iconStyle} /></span>}>
                                {LeftDropdown(true, activeItem, showAboutModal, hasAdminPrivileges, auth)}
                            </Dropdown>
                            <div style={{ display: "flex", marginLeft: "auto" }}>
                                <a className="header item"><img src={logoImg!} id="nav-logo-2" alt='FYB CM2WebShare Logo' style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/')} /></a>
                            </div>
                        </Menu.Menu>
                    </Grid.Row>
                </Grid>
            </Menu>
            <About open={openAbout} onClose={() => {setOpenAbout(false)}} />
        </div>
    );
}

export default NavMenu;